// extracted by mini-css-extract-plugin
export default {"wrapper":"SettingHeader_wrapper__---8Q","goBack":"SettingHeader_goBack__ea1o1","container":"SettingHeader_container__nY9Gw","title":"SettingHeader_title__TEwVG"};